import type { ActivityModule } from '../../core/activity';
import { mountTarget } from './ui';
import levelsData from './levels.json';
import './style.css';

export const target: ActivityModule = {
  id: 'target',
  title: 'Arco e flecha',
  description: 'Atire as flechas no alvo e some os pontos. Cuidado: o alvo se mexe!',
  ageMin: 6,
  ageMax: 10,
  difficulty: 3,
  iconPath: 'assets/gcompris-AGPL/target/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount: mountTarget,
};
